export const TooltipPosition = Object.freeze({
    LEFT: 'left',
    LEFT_START: 'left-start',
    LEFT_END: 'left-end',
    RIGHT: 'right',
    RIGHT_START: 'right-start',
    RIGHT_END: 'right-end',
    TOP: 'top',
    TOP_START: 'top-start',
    TOP_END: 'top-end',
    BOTTOM: 'bottom',
    BOTTOM_START: 'bottom-start',
    BOTTOM_END: 'bottom-end',
});

export const TextPosition = Object.freeze({
    RIGHT: 'right',
    CENTER: 'center',
    LEFT: 'left'
});

export const TOOLTIP_PROP_NAME = 'customTooltip';
/**
 * @enum {string}
 * @type {Readonly<{NAME: string, VALUE: string}>}
 */
export const TemplateVariable = Object.freeze({
    NAME: 'n',
    VALUE: 'v'
});

/**
 * @enum {string}
 * @type {Readonly<{STRING: string, NUMBER: string, DATE: string}>}
 */
export const TooltipDataItemValueType = Object.freeze({
   STRING: 'string',
   NUMBER: 'number',
   DATE: 'date'
});

export const ITEM_CSS_CLASS = 'data-item';

export const DELAY_TIME = 150;
